import { useEffect } from 'react';

export function useAnalytics() {
  useEffect(() => {
    const gaId = import.meta.env.VITE_GA_ID;
    const adsenseClient = import.meta.env.VITE_ADSENSE_CLIENT;

    // Google Analytics
    if (gaId) {
      // Load gtag.js script
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(gtagScript);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', gaId);

      // Make gtag globally accessible
      window.gtag = gtag;
    }

    // Google AdSense
    if (adsenseClient) {
      const adsenseScript = document.createElement('script');
      adsenseScript.async = true;
      adsenseScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseClient}`;
      adsenseScript.crossOrigin = 'anonymous';
      document.head.appendChild(adsenseScript);
    }
  }, []);
}
